import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
// import classnames from 'classnames';
import { ListTable } from 'gnos-tables'
import _ from 'lodash'

import NoData from '../../../../../../../../../components/Workspace/components/NoData'

import { LOCALE_PREFIX } from '../../constants'
import './style.scss'

@injectIntl
export default class SecondarySic extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        tableData: PropTypes.object,
        translates: PropTypes.shape({
            activitiesTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }),
    }

    renderTable = () => {
        const { id, tableData, translates, intl } = this.props

        if (_.isEmpty(_.get(tableData, '_table[0].tables[0].rows'))) {
            return <NoData text={<FormattedMessage id={`${LOCALE_PREFIX}.noTableData`} />} />
        }

        return (
            <ListTable
                key={'secondary-sic-table'}
                id={`secondary-sic-table-${id}`}
                staticData={tableData}
                columnsDefinition={{
                    title: {
                        Cell: () => <span style={{ color: '#666' }}>{translates.activitiesTitle}</span>,
                        width: 200,
                    },
                    top: {
                        columns: [
                            {
                                accessor: 'value',
                                Cell: ({ value }) => (
                                    <div>
                                        <span>{value}</span>
                                    </div>
                                ),
                            },
                            {
                                accessor: 'number',
                                Cell: ({ value }) => <span>{value}</span>,
                                width: 100,
                            },
                        ],
                    },
                }}
                texts={{
                    loading: intl.formatMessage({ id: 'global.loading' }),
                    noData: intl.formatMessage({ id: 'global.noData' }),
                    controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                    controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                    controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                    controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                    controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                    controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                }}
            />
        )
    }

    render() {
        return <div className={'secondary-sic-tab-content'}>{this.renderTable()}</div>
    }
}
